export default __webpack_public_path__ + "static/media/patient-room-3.aa2fba61.jpg";